<template>
	<div>
		<div class="msg_box">
			<div class="tech_title">产品相关视频</div>
			<div v-loading="loading" class="vid_box min_he200">
				<div class="vid_zi" v-for="item in videoList" :key='item.id'>
					<div @click="xin.goUrl('/videos/'+item.id)" class="vid_zi_img li_chin">
						<img :src="item.video_images"/>
						<div class="vid_zi_icon"><span class="iconfont icon-bofang"></span></div>
					</div>
					<div class="vid_zi_title">{{item.title}}</div>
				</div>
			</div>
			<el-pagination class="feye" :background="true" :current-page.sync="pageNo" :page-size="limit" layout="prev, pager, next, jumper"
			:total="total" @current-change="pageCurrentChange" :hide-on-single-page="true"></el-pagination>
		</div>
	</div>
</template>

<script>
export default{
	data(){
		return {
			loading:true,
			videoList:[],
			total:0,//总数量
			pageNo:1,//当前页
			limit:0,//一页多少条
		}
	},
	created(){
		this.Postvideo();
	},
	methods:{
		async Postvideo(){
			this.loading = true;
			let {data} = await this.api.Postvideo({page:this.pageNo});
			this.videoList = data.data;
			this.total = data.total;
			this.limit = data.per_page;
			this.loading = false;
		},
		pageCurrentChange(val) {//分页查询
			this.pageNo = val;
			this.Postvideo();
		},
	}
}
</script>

<style lang="scss" scoped>
.feye{
	margin-top: 50px;
	display: flex;
	justify-content: center;
}
	.vid_box{
		margin-top: 50px;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		.vid_zi{
			margin-top: 50px;
			width: 380px;
			.vid_zi_img{
				// height: 285px;
				position: relative;
				img{
					width: 100%;
					height: 100%;
					display: block;
					transition:none;
					&:hover{
						transform:none;
					}
				}
				.vid_zi_icon{
					cursor: pointer;
					.iconfont{
						font-size: 30px;
					}
					width: 80px;
					height: 80px;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%,-50%);
					display: flex;
					justify-content: center;
					align-items: center;
					color: #fff;
					border: 2px solid #fff;
					border-radius: 50%;
				}
			}
			
			.vid_zi_title{
				font-weight: 500;
				color: #333333;
				text-align: center;
				line-height: 30px;
			}
		}
	}
</style>
